import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDispatch } from 'react-redux';
import * as Actions from 'app/store/actions';
import PropTypes from 'prop-types';

/**
 * A dialog to confirm the DELETE action for redux store.
 * @param {func} cbConfirm Delete function to dispatch in the redux store.
 * @param {string} message
 */
function ConfirmDialog({ cbConfirm, message }) {
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = React.useState(true);

	const onConfirm = () => {
		setIsOpen(false);
		cbConfirm(true);
		dispatch(Actions.closeDialog());
	};

	const onCancel = () => {
		setIsOpen(false);
		cbConfirm(false);
		dispatch(Actions.closeDialog());
	};

	return (
		<div>
			<Dialog
				open={isOpen}
				onClose={onCancel}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{'Are you sure?'}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={onCancel} color="primary">
						Cancel
					</Button>
					<Button onClick={onConfirm} variant="contained" color="primary">
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

ConfirmDialog.propTypes = {
	cbConfirm: PropTypes.func.isRequired,
	message: PropTypes.string.isRequired
};

export default ConfirmDialog;
